import React from 'react';
import '../styles/Links.scss';

const Links = () => {
  const links = [
    { text: 'LinkedIn', href: 'http://www.linkedin.com/in/zakfisher' },
    { text: 'Github', href: 'http://www.github.com/zakfisher' },
    { text: 'Twitter', href: 'http://www.twitter.com/_zak_fisher' },
    { text: 'Resume', href: 'https://drive.google.com/open?id=18z2lB6OddK5WnnIWYYY18UTZeyf8XhBgRMwPnsaeob0' }
  ];
  return (
    <div className="Links col-12 tab-6">
      <div className="bg" />
      <ul>
        {links.map((link, i) => (
          <li key={i}>
            <a href={link.href} target='_blank'>{link.text}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Links;



// WEBPACK FOOTER //
// ./src/components/Links.js